import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    languages: [],
    languagesMetadata: {},
    language: {},
    deviceLanguages: []
  }
})
  .get({
    action: 'getLanguages',
    property: 'languages',
    queryParams: true,
    path: '/languages/',
    onSuccess: payloadToState('languages')
  })
  .get({
    action: 'getDeviceLanguages',
    property: 'deviceLanguages',
    path: ({ languageId }) => `/languages/device-languages/${languageId}`,
    onSuccess: payloadToState('deviceLanguages')
  })
  .post({
    action: 'createLanguage',
    property: 'language',
    path: '/languages/',
    onSuccess: payloadToState('language')
  })
  .get({
    action: 'getLanguage',
    property: 'language',
    path: ({ id }) => `/languages/${id}`,
    onSuccess: payloadToState('language')
  })
  .put({
    action: 'updateLanguage',
    property: 'language',
    path: ({ id }) => `/languages/${id}`,
    onSuccess: payloadToState('language')
  })
  .delete({
    action: 'deleteLanguage',
    property: 'language',
    path: ({ id }) => `/languages/${id}`,
    onSuccess: payloadToState('language')
  })
  .getStore()
